<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-title">TABLE OF CONTENTS</h2>
<p class="line"> </p>
<p class="toc"><a href="#/toc2">50 PASSAWAYS TO RICHES</a></p>
<p class="toc"><a href="#/ack">ACKNOWLEDGEMENTS</a></p>
<p class="toc"><a href="#/intro">INTRODUCTION</a></p>
<p class="toc"><a href="#/prologue">PROLOGUE</a></p>
<p class="toc1"><a href="#/chap001">1 THE TIME MACHINE</a></p>
<p class="toc1"><span href="#/chap002" title="Link target outside of Sample">2 DUNGEON OF PAIN</span></p>
<p class="toc1"><span href="#/chap003" title="Link target outside of Sample">3 OTHER PEOPLE'S MINDS</span></p>
<p class="toc1"><span href="#/chap004" title="Link target outside of Sample">4 A VERY TALL ORDER</span></p>
<p class="toc1"><span href="#/chap005" title="Link target outside of Sample">5 THE ORIGIN OF SPECIES</span></p>
<p class="toc1"><span href="#/chap006" title="Link target outside of Sample">6 ABRA C' DABRA</span></p>
<p class="toc1"><span href="#/chap007" title="Link target outside of Sample">7 DEATH AND TAXES</span></p>
<p class="toc1"><span href="#/chap008" title="Link target outside of Sample">8 THE WISDOM OF AN APACHE INDIAN CHIEF</span></p>
<p class="toc1"><span href="#/chap009" title="Link target outside of Sample">9 THOUGHT, SPEECH, AND ACTION</span></p>
<p class="toc2"><span href="#/chap010" title="Link target outside of Sample">10 BIG VALUABLE ROCKS</span></p>
<p class="toc2"><span href="#/chap011" title="Link target outside of Sample">11 AN ANGELIC DISPLAY</span></p>
<p class="toc2"><span href="#/chap012" title="Link target outside of Sample">12 THE PASSIONATE KISS</span></p>
<p class="toc2"><span href="#/chap013" title="Link target outside of Sample">13 THE PSYCHIC MENTOR AND SUPER MENTEES</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?01edd34b